<h2>Protocolo Volei</h2>
<p>Aqui descrevo os procotolos que são executados do momento que o árbitro chega no sítio onde o jogo será iniciado até
  o momento do seu início</p>
<p>Para efetuar o cálculo para o seu jogo, altere a hora no campo abaixo</p>


<div class="row">
  <div class="col-6">
    <div class="row mb-3">
      <div class="col-auto"><label for="gameTime" class="col-form-label">Hora do jogo</label></div>
      <div class="col-auto"><input type="time" [(ngModel)]="gameStartTime" (ngModelChange)="onDataChange()"
          class="form-control" maxlength="5"></div>
    </div>
  </div>
  <div class="col-6">
    <div class="row mb-3">
      <div class="col-auto"><label for="refereeType" class="col-form-label">Tipo</label></div>
      <div class="col-auto"><select id="refereeType" [(ngModel)]="refereeType" class="form-select">
          <option [ngValue]="1">1 Árbitro</option>
          <option [ngValue]="2">2 Árbitros</option>
        </select></div>
    </div>
  </div>
  @if (!isLoaded) {
  <div><i class="fas fa-spinner fa-spin"></i></div>
  }
  @if (isLoaded) {
  <div>
    @for (item of filteredVoleiProtocols; track item; let i = $index) {
    <div class="col-12">
      <div class="card mb-3">
        <div class="card-header">
          <div class="row">
            @if (i<(filteredVoleiProtocols.length-1)) { <div class="col-10">{{toTime(gameStartTime,
              $safeNavigationMigration(item?.timeBefore))}}<br /><span style="font-size: 0.7em;">{{toMinutesStr($safeNavigationMigration(item?.timeBefore))}}</span></div>
          }
          @if (i==(filteredVoleiProtocols.length-1)) {
          <div class="col-10"><span>Fim de jogo!</span></div>
          }
          <div class="col-2 text-end"><a (click)="openObservations(item)" data-bs-toggle="modal"
              data-bs-target="#exampleModal"><i class="fa fa-info-circle" aria-hidden="true"></i></a></div>
        </div>
      </div>
      <div class="card-body">
        <h3 class="card-title">{{item?.name}}</h3>
      </div>
    </div>
  </div>
  }
</div>
}
</div>
<div class="card mb-3">
  <div class="card-header">
    <h2>Resultado do jogo</h2>
  </div>
  <div class="card-body">
    <p>Para efetuar o cálculo para o seu jogo, insira os dados nos campos existentes</p>
    <div class="custom-table-wrapper">
      <table class="table table-sm table-bordered">
        <tbody>
          <!-- Header Rows -->
          <tr>
            <th colspan="10" class="text-center">RESULTADO</th>
          </tr>
          <tr>
            <td colspan="5" class="text-center"><b>EQUIPA A</b></td>
            <td colspan="5" class="text-center"><b>EQUIPA B</b></td>
          </tr>
          <tr>
            <td class="text-center middle-text w-1d"><b>T</b></td>
            <td class="text-center middle-text w-1d"><b>S</b></td>
            <td class="text-center middle-text w-1d"><b>V</b></td>
            <td class="text-center middle-text w-2d"><b>P</b></td>
            <td colspan="2" class="text-center w-2d"><b>SET (MIN)</b></td>
            <td class="text-center middle-text w-2d"><b>P</b></td>
            <td class="text-center middle-text w-1d"><b>V</b></td>
            <td class="text-center middle-text w-1d"><b>S</b></td>
            <td class="text-center middle-text w-1d"><b>T</b></td>
          </tr>

          <!-- Set Data Rows -->
          @for (set of sets; track trackBySetNumber($index, set)) {
          <tr>
            <td class="w-1d"><input type="number" class="form-control form-control-sm text-center" min="0" max="2"
                [(ngModel)]="set.teamA.t" (ngModelChange)="onDataChange()"></td>
            <td class="w-1d"><input type="number" class="form-control form-control-sm text-center" min="0" max="5"
                [(ngModel)]="set.teamA.s" (ngModelChange)="onDataChange()"></td>
            <td class="w-1d"><input type="number" class="form-control form-control-sm text-center" min="0" max="1"
                [(ngModel)]="set.teamA.v" (ngModelChange)="onDataChange()"></td>
            <td class="w-2d"><input type="number" class="form-control form-control-sm text-center" min="0" max="99"
                [(ngModel)]="set.teamA.p" (ngModelChange)="onDataChange()"></td>
            <td class="text-center middle-text w-set"><b>{{ set.setNumber }}</b></td>
            <td class="w-2d"><input type="number" class="form-control form-control-sm text-center" min="0" max="99"
                [(ngModel)]="set.duration" (ngModelChange)="onDataChange()"></td>
            <td class="w-2d"><input type="number" class="form-control form-control-sm text-center" min="0" max="99"
                [(ngModel)]="set.teamB.p" (ngModelChange)="onDataChange()"></td>
            <td class="w-1d"><input type="number" class="form-control form-control-sm text-center" min="0" max="9"
                [(ngModel)]="set.teamB.v" (ngModelChange)="onDataChange()"></td>
            <td class="w-1d"><input type="number" class="form-control form-control-sm text-center" min="0" max="99"
                [(ngModel)]="set.teamB.s" (ngModelChange)="onDataChange()"></td>
            <td class="w-1d"><input type="number" class="form-control form-control-sm text-center" min="0" max="99"
                [(ngModel)]="set.teamB.t" (ngModelChange)="onDataChange()"></td>
          </tr>
          }

          <!-- Totals -->
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td colspan="2" class="text-center"><b>DURAÇÃO TOTAL (MIN)</b></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="text-center"><b>{{ teamATotals.t }}</b></td>
            <td class="text-center"><b>{{ teamATotals.s }}</b></td>
            <td class="text-center"><b>{{ teamATotals.v }}</b></td>
            <td class="text-center"><b>{{ teamATotals.p }}</b></td>
            <td colspan="2" class="text-center"><b>{{ totalSetDurationMinutes }}</b></td>
            <td class="text-center"><b>{{ teamBTotals.p }}</b></td>
            <td class="text-center"><b>{{ teamBTotals.v }}</b></td>
            <td class="text-center"><b>{{ teamBTotals.s }}</b></td>
            <td class="text-center"><b>{{ teamBTotals.t }}</b></td>
          </tr>

          <!-- Game Timing -->
          <tr>
            <td colspan="4" class="text-center middle-text"><b>INÍCIO</b></td>
            <td colspan="2" class="text-center middle-text"><b>FIM</b></td>
            <td colspan="4" class="text-center middle-text"><b>DURAÇÃO TOTAL</b></td>
          </tr>
          <tr>
            <td colspan="4" class="text-center align-middle">
              <input type="time" class="form-control form-control-sm d-block mx-auto" [(ngModel)]="gameStartTime"
                (ngModelChange)="onDataChange()" style="width: 90px;">
            </td>
            <td colspan="2" class="text-center align-middle">
              {{ gameEndTime }}
            </td>
            <td colspan="4" class="text-center align-middle">
              <b>{{ totalGameDurationFormatted }}</b><br>
              @if (playedSetsCount > 1) {
              <small>({{ totalSetDurationMinutes }}m sets + {{ totalBreakTimeMinutes }}m breaks)</small>
              }
              @if (playedSetsCount <= 1) { <small>({{ totalSetDurationMinutes }}m sets)</small>
                }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        @if (itemProtocol) {
        <h2 class="modal-title fs-5" id="exampleModalLabel">{{itemProtocol.name}}</h2>
        }
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        @if (itemProtocol) {
        <span [innerHtml]="itemProtocol.observations"></span>
        }
      </div>
    </div>
  </div>
</div>